import React, {useEffect, useState} from "react";
import {connect} from "react-redux";
import {useSearchParams} from "react-router-dom";
import {CButton, CCol, CForm, CFormLabel, CRow} from "@coreui/react";
import * as o2Api from "../../../../../api/api";
import numeral from "numeral";
import {Loading} from "../../../../../components/common";
import {AgGridColumn, AgGridReact} from "ag-grid-react";
import * as formatter from "../../../../../config/formatter";

const SaleBillDetail = () => {
    const [params] = useSearchParams();
    const [loading, setLoading] = useState(false);
    const [saleHd, setSaleHd] = useState([{
        saleAmt: 0, payAmt: 0, dcAmt: 0, vatAmt: 0, netAmt: 0, serviceAmt: 0
    }]);
    const [saleDt, setSaleDt] = useState([]);
    const [saleSt, setSaleSt] = useState([{
        payAmt: 0, payDiv: "10"
    }]);
    const queryList = [...params];
    const seq = queryList[0][1];

    const defaultColDef = {
        flex: 1,
        resizable: true,
        sortable: true,
        filter: false,
        autoHeaderHeight: true
    };

    const [columnDefs] = useState([
        {headerName: "No", maxWidth: 70, valueGetter: "node.rowIndex + 1", cellClass: "static-cell"},
        {field: "storeNm", headerName: "매장", maxWidth: 100},
        {field: "productNm", headerName: "상품명", minWidth: 150},
        {field: "saleQty", headerName: "수량", maxWidth: 50},
        {field: "salePrice", headerName: "단가", maxWidth: 100, valueFormatter: formatter.currencyFormatter, cellClass: "number-cell"},
        {field: "saleAmt", headerName: "총매출액", valueFormatter: formatter.currencyFormatter, cellClass: "number-cell"},
        {field: "dcAmt", headerName: "총할인액", valueFormatter: formatter.currencyFormatter, cellClass: "number-cell"},
        {field: "payAmt", headerName: "실매출액", valueFormatter: formatter.currencyFormatter, cellClass: "number-cell"},
        {
            field: "netAmt", headerName: "가액", valueGetter: (e) => {
                return e.data.payAmt - e.data.vatAmt;
            }, valueFormatter: formatter.currencyFormatter, cellClass: "number-cell"
        },
        {field: "vatAmt", headerName: "부가세", valueFormatter: formatter.currencyFormatter, cellClass: "number-cell"},
    ]);

    useEffect(() => {
        getSaleHd(seq);
    }, []);

    const getSaleHd = (seq) => {
        setLoading(true);
        o2Api.getDetailCurrentDaySaleHd(seq).then((result) => {
            const {responseBody, responseCode, responseMessage} = result.data;
            console.log("### response :: ", responseBody);
            if (responseCode === "200") {
                setLoading(false);
                setSaleHd(responseBody);
                getSaleDt(seq);
            } else {
                setLoading(false);
            }
        });
    }

    const getSaleDt = (seq) => {
        setLoading(true);
        o2Api.getDetailCurrentDaySaleDt(seq).then((result) => {
            const {responseBody, responseCode, responseMessage} = result.data;
            console.log("### response :: ", responseBody);
            if (responseCode === "200") {
                setLoading(false);
                setSaleDt(responseBody);
                getSaleSt(seq);
            } else {
                setLoading(false);
            }
        });
    }

    const getSaleSt = (seq) => {
        setLoading(true);
        o2Api.getDetailCurrentDaySaleSt(seq).then((result) => {
            const {responseBody, responseCode, responseMessage} = result.data;
            console.log("### response :: ", responseBody);
            if (responseCode === "200") {
                setLoading(false);
                setSaleSt(responseBody);
            } else {
                setLoading(false);
            }
        });
    }

    const goCash = (seq) => {
        // window.open('/#/sale/detail/pay?' + params, "_pay", "width=800, height=400");
    }

    const goCard = (seq) => {
        // window.open('/#/sale/detail/pay?' + params, "_pay", "width=800, height=400");
    }

    return (
        <>
            <div style={{padding: 16}}>
                {loading ? <Loading/> : null}
                <div style={{borderRadius: 5, padding: 10, marginBottom: 10, background: "#13319b"}}>
                    <span
                        style={{color: 'white', fontWeight: 600}}>매장 : [{saleHd[0].storeCd}] {saleHd[0].storeNm}</span>
                </div>
                <CRow>
                    <CCol xs={6}>
                        <div style={{borderRadius: 5, padding: 10, marginBottom: 10, background: "#87CEFA"}}>
                            종합내역
                        </div>
                        <div className={"d-flex flex-row justify-content-between"}>
                            <div className={"p-2 bg-light"} style={{width: 100}}>총매출액</div>
                            <div className={"p-2"} style={{width: 100}}>{numeral(saleHd[0].saleAmt).format("0,0")} 원</div>
                            <div className={"p-2 bg-light"} style={{width: 100}}>총할인액</div>
                            <div className={"p-2"} style={{width: 100}}>{numeral(saleHd[0].dcAmt).format("0,0")} 원</div>
                        </div>
                        <div className={"d-flex flex-row justify-content-between"}>
                            <div className={"p-2 bg-light"} style={{width: 100}}>실매출액</div>
                            <div className={"p-2"} style={{width: 100}}>{numeral(saleHd[0].payAmt).format("0,0")} 원</div>
                            <div className={"p-2 bg-light"} style={{width: 100}}>순매출액</div>
                            <div className={"p-2"} style={{width: 100}}>{numeral(saleHd[0].netAmt).format('0,0')} 원</div>
                        </div>
                        <div className={"d-flex flex-row justify-content-between"}>
                            <div className={"p-2 bg-light"} style={{width: 100}}>부가세액</div>
                            <div className={"p-2"} style={{width: 100}}>{numeral(Math.round(saleHd[0].payAmt - (saleHd[0].payAmt / 1.1))).format("0,0")} 원</div>
                            <div className={"p-2 bg-light"} style={{width: 100}}>봉사료</div>
                            <div className={"p-2"} style={{width: 100}}>{numeral(saleHd[0].serviceAmt).format('0,0')} 원</div>
                        </div>
                    </CCol>
                    <CCol xs={6}>
                        <div style={{borderRadius: 5, padding: 10, marginBottom: 10, background: "#87CEFA"}}>
                            결제내역
                        </div>
                        <div className={"d-flex flex-row justify-content-between"}>
                            <div className={"p-2 bg-light table-header"} style={{width: 100}} onClick={() => goCash(seq)}>현금</div>
                            <div className={"p-2"} style={{width: 100}}>
                                {saleSt[0].payDiv === '10' ? numeral(saleSt[0].payAmt).format('0,0') : 0} 원
                            </div>
                            <div className={"p-2 bg-light"} style={{width: 100}}>신용카드</div>
                            <div className={"p-2"} style={{width: 100}} onClick={() => goCard(seq)}>
                                {saleSt[0].payDiv === '20' ? numeral(saleSt[0].payAmt).format('0,0') : 0} 원
                            </div>
                        </div>
                        <div className={"d-flex flex-row justify-content-between"}>
                            <div className={"p-2 bg-light"} style={{width: 100}}>상품권</div>
                            <div className={"p-2"} style={{width: 100}}>0 원</div>
                            <div className={"p-2 bg-light"} style={{width: 100}}>회원포인트</div>
                            <div className={"p-2"} style={{width: 100}}>0 원</div>
                        </div>
                        <div className={"d-flex flex-row justify-content-between"}>
                            <div className={"p-2 bg-light"} style={{width: 100}}>제휴카드</div>
                            <div className={"p-2"} style={{width: 100}}>0 원</div>
                            <div className={"p-2"} style={{width: 100}} />
                            <div className={"p-2"} style={{width: 100}} />
                        </div>
                    </CCol>
                </CRow>
                <div style={{height: 10}} />
                <CRow>
                    <CCol xs={12}>
                        <div style={{borderRadius: 5, padding: 10, marginBottom: 10, background: "#87CEFA"}}>
                            상품내역
                        </div>
                        <div className="ag-theme-alpine" style={{width: "100%", height: 250, marginTop: 10}}>
                            <AgGridReact
                                rowSelection={"single"}
                                headerHeight={30}
                                rowHeight={30}
                                rowData={saleDt}
                                animateRows={true}
                                defaultColDef={defaultColDef}
                                columnDefs={columnDefs}>
                            </AgGridReact>
                        </div>
                    </CCol>
                </CRow>
            </div>
        </>
    )
}

export default connect(null, null)(SaleBillDetail);
